import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';

import Loading from '../../../../shared/loading';
import Validator from '../../../../shared/validator';
import SingleDatePickerWrapper from '../../../../shared/single-date-picker-wrapper';
import mutate from '../../../../shared/mutate';

function getTimesForDate(date) {
  const step = 15;
  const now = moment();
  const isToday = date && date.isSame(now, 'day');
  const times = [];
  if (date) {
    const p = isToday
      ? now.clone().minute(Math.ceil(now.minute() / 15) * 15)
      : date.clone().set({ hour: 0, minute: 0 });
    while (p.isSame(date, 'day')) {
      times.push(p.format('hh:mm a'));
      p.add(step, 'minutes');
    }
  }
  return times;
}

export default class AutoPublishWireModal extends React.Component {
  static propTypes = {
    onAutoPublishSettingsUpdated: PropTypes.func.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    this.validator = new Validator({
      dateTimeRequired: state => state.dateTime && state.dateTime.isValid() && state.time !== '',
    });

    this.state = {
      show: false,
      dateTime: null,
      time: '',
      validations: this.validator.getValidations(),
    };
  }

  handleDateChange(date) {
    this.setState(oldState => mutate(oldState, state => {
      if (!!date && date.isValid()) {
        state.dateTime = date;
      } else {
        state.dateTime = null;
        state.time = '';
      }

      state.validations.dateTimeRequiredValid = this.validator.validateDateTimeRequired(state);
    }));
  }

  handleTimeChange(e) {
    const time = e.target.value;

    this.setState(oldState => mutate(oldState, state => {
      state.time = time;

      const validationResult = this.validator.validateDateTimeRequired(state);
      state.validations.dateTimeRequiredValid = validationResult;

      if (validationResult) {
        const t = moment(time, 'hh:mm a');

        state.dateTime.set({
          hour: t.hour(),
          minute: t.minute(),
        });
      }
    }));
  }

  setAutoPublishAt() {
    this.setState(
      state => ({ validations: this.validator.validateForm(state) }),
      () => {
        if (!this.validator.formValid) return;

        this.props.onAutoPublishSettingsUpdated(this.state.dateTime);
        this.dismiss();
      },
    );
  }

  present(dateTime) {
    this.validator.resetValidation();
    const time = (!!dateTime && dateTime.isValid()) ? dateTime.format('hh:mm a') : '';
    this.setState({
      show: true,
      dateTime,
      time,
      validations: this.validator.getValidations(),
    });
  }

  dismiss() {
    this.setState({ show: false });
  }

  render() {
    return (
      <Modal
        centered="true"
        dialogAs="article"
        show={this.state.show}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title as="h4">Schedule</Modal.Title>
        </Modal.Header>
        <Modal.Body as="section">
          <Loading ref={el => (this.loading = el)}>
            <form>
              <div className={`form-group ${this.state.validations.dateTimeRequiredValid ? '' : 'has-error'}`}>
                {/*
                  eslint
                  jsx-a11y/label-has-associated-control: [
                    2,
                    { controlComponets: ["SingleDatePickerWrapper"] },
                  ]
                */}
                <label htmlFor="auto-publish-select-date">
                  Publish date:
                  <SingleDatePickerWrapper
                    id="auto-publish-select-date"
                    initialDate={this.state.dateTime}
                    onDateChange={date => this.handleDateChange(date)}
                  />
                </label>
              </div>
              <div className={`form-group ${this.state.validations.dateTimeRequiredValid ? '' : 'has-error'}`}>
                <label htmlFor="auto-publish-select-time">
                  Publish time:
                  <select
                    id="auto-publish-select-time"
                    value={this.state.time}
                    onChange={e => this.handleTimeChange(e)}
                  >
                    <option key="unset" value="">Unset</option>
                    {getTimesForDate(this.state.dateTime).map(time => (
                      <option key={time} value={time}>{time}</option>
                    ))}
                  </select>
                </label>
                {this.state.validations.dateTimeRequiredValid || <span className="help-block">Both the auto-publish date and time must be provided</span>}
              </div>
              <p className="info-block text-small">Date and time are in AEST/AEDT timezone.</p>
            </form>
          </Loading>
        </Modal.Body>
        <Modal.Footer as="footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => this.dismiss()}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => this.setAutoPublishAt()}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
